"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "castiraga-vidardo": {
    "a36bbe23": [{
      "hkey": "6f8ee1c7",
      "slug": "pollarana",
      "name": "Pollarana",
      "primary": true,
      "skipSearch": false
    }],
    "cascina-pollarana": [{
      "hkey": "6f8ee1c7",
      "slug": "pollarana",
      "name": "Pollarana",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "28166609": [{
      "hkey": "9216effa",
      "slug": "castiraga-vidardo",
      "name": "Castiraga Vidardo",
      "primary": true,
      "skipSearch": false
    }],
    "cascina-rosa": [{
      "hkey": "9216effa",
      "slug": "castiraga-vidardo",
      "name": "Castiraga Vidardo",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "15d06119": [{
      "hkey": "9216effa",
      "slug": "castiraga-vidardo",
      "name": "Castiraga Vidardo",
      "primary": true,
      "skipSearch": false
    }],
    "monteoliveto": [{
      "hkey": "9216effa",
      "slug": "castiraga-vidardo",
      "name": "Castiraga Vidardo",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "9d92e11b": [{
      "hkey": "9216effa",
      "slug": "castiraga-vidardo",
      "name": "Castiraga Vidardo",
      "primary": true,
      "skipSearch": false
    }],
    "mulino": [{
      "hkey": "9216effa",
      "slug": "castiraga-vidardo",
      "name": "Castiraga Vidardo",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "bc85009a": [{
      "hkey": "9216effa",
      "slug": "castiraga-vidardo",
      "name": "Castiraga Vidardo",
      "primary": true,
      "skipSearch": false
    }],
    "palazzola": [{
      "hkey": "9216effa",
      "slug": "castiraga-vidardo",
      "name": "Castiraga Vidardo",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "92156108": [{
      "hkey": "a2518377",
      "slug": "cartiera-vidardino",
      "name": "Cartiera-Vidardino",
      "primary": true,
      "skipSearch": false
    }],
    "vidardino": [{
      "hkey": "a2518377",
      "slug": "cartiera-vidardino",
      "name": "Cartiera-Vidardino",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;